import * as React from "react";
import { CSSTransition, TransitionGroup } from "react-transition-group";
//const CSSTransitionGroup:any = require('react-transition-group/TransitionGroup');
const IconChevron = require('!svg-react-loader?name=LiquorIcon!../../wwwroot/img/icons/icon-chevron.svg');
export default class MobileMenu extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        let menu = React.createElement(CSSTransition, { classNames: {
                enter: 'fadeInLeft',
                exit: 'fadeOutRight',
                appear: ''
            }, timeout: {
                enter: 300,
                exit: 300
            } },
            React.createElement("div", { className: "menu animated" },
                React.createElement("ul", { className: "primary" },
                    React.createElement("li", null,
                        React.createElement("a", { href: "/Products/Search?madeInAlberta=true" },
                            "Alberta Made",
                            React.createElement(IconChevron, null))),
                    React.createElement("li", null,
                        React.createElement("a", { href: "/Products/Search?category=WINE" },
                            "Wine",
                            React.createElement(IconChevron, null))),
                    React.createElement("li", null,
                        React.createElement("a", { href: "/Products/Search?category=BEER" },
                            "Beer",
                            React.createElement(IconChevron, null))),
                    React.createElement("li", null,
                        React.createElement("a", { href: "/Products/Search?category=SPIRITS" },
                            "Spirits",
                            React.createElement(IconChevron, null))),
                    React.createElement("li", null,
                        React.createElement("a", { href: "/Products/Search?category=LIQUEUR" },
                            "Liqueurs",
                            React.createElement(IconChevron, null))),
                    React.createElement("li", null,
                        React.createElement("a", { href: "/Products/Search?category=CIDERS%20%26%20COOLERS" },
                            "Ciders & Coolers",
                            React.createElement(IconChevron, null))),
                    React.createElement("li", null,
                        React.createElement("a", { href: "/Products/Search?liqType=NON-ALCOHOLIC&category=NON-ALCOHOLIC" },
                            "Non-Alcoholic",
                            React.createElement(IconChevron, null))),
                    React.createElement("li", null,
                        React.createElement("a", { href: "/Products/Search?liqType=LIQUOR%20ACCESSORIES%2CPRODUCT%20PACKAGING&category=NON-ALCOHOLIC" },
                            "Other",
                            React.createElement(IconChevron, null)))),
                React.createElement("ul", { className: "secondary" },
                    React.createElement("li", null,
                        React.createElement("a", { href: "/Home/StoreLocator" },
                            "Store Locator",
                            React.createElement(IconChevron, null))),
                    React.createElement("li", null,
                        React.createElement("a", { href: "/Home/Events" },
                            "Events",
                            React.createElement(IconChevron, null))),
                    React.createElement("li", null,
                        React.createElement("a", { href: "/Home/Contact" },
                            "Contact",
                            React.createElement(IconChevron, null))),
                    React.createElement("li", null,
                        React.createElement("a", { href: "/Home/PrivacyPolicy" },
                            "Privacy Policy",
                            React.createElement(IconChevron, null))),
                    React.createElement("li", null,
                        React.createElement("a", { href: "/Home/Social" },
                            "Social Responsibility",
                            React.createElement(IconChevron, null))),
                    React.createElement("li", null,
                        React.createElement("a", { href: "/Home/Faq" },
                            "FAQ",
                            React.createElement(IconChevron, null))))));
        return this.props.toggle ? (React.createElement("div", { className: "mobile-menu" },
            React.createElement("div", { className: "menu-bg", onClick: this.props.toggleMobile }),
            React.createElement(TransitionGroup, null, menu))) : null;
    }
}
;
//# sourceMappingURL=mobile-menu.js.map